module.exports = __webpack_public_path__ + "img/rise.3b4ac222.svg";